<template>
  <div class="sort-list">
    <UiRadio
      v-for="item of list"
      :key="item.value"
      class="sort-list__radio"
      :label="item.label"
      :value="item.value"
      :isChecked="item.isChecked"
      @inputValue="updateSelectedSort(item.value)"
    />
  </div>
</template>

<script setup lang="ts">
  import { UiRadio } from '@experience/core-radio-ui';
  import { useI18n } from '@experience/i18n';
  import ru from '../../i18n/ru.json';
  import { Sort } from '../../types';

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const list = ref([
    {
      value: Sort.popularity,
      label: t('sortList.popularity'),
      isChecked: true,
    },
    {
      value: Sort.publishedAt,
      label: t('sortList.publishedAt'),
      isChecked: false,
    },
    {
      value: Sort.price,
      label: t('sortList.price'),
      isChecked: false,
    },
    {
      value: Sort.rating,
      label: t('sortList.rating'),
      isChecked: false,
    },
  ]);

  const selectedSort = defineModel<string | null>();

  const updateSelectedSort = (value: string) => {
    selectedSort.value = value;
    updateCheckedState();
  };

  const updateCheckedState = () => {
    if (!selectedSort.value) {
      selectedSort.value = Sort.popularity;

      return;
    }

    list.value.forEach((item) => {
      item.isChecked = item.value === selectedSort.value;
    });
  };

  watch(selectedSort, updateCheckedState, { immediate: true });
</script>

<style scoped lang="scss">
  .sort-list {
    display: flex;
    flex-direction: column;
    align-items: start;
  }

  .sort-list__radio {
    display: flex;
    align-items: center;
    height: 48px;
  }
</style>
